import { ARC_ENVIRONMENT } from './arc-env';
const MemberLifecycleConfigs = {
  dev: {
    enabled: true,
    reminderAfterDays: 7,
    actionAfterDays: 7,
    action: 'none',
    recipients: ['arcdev@avb.net']
  },
  staging: {
    enabled: false,
    reminderAfterDays: 7,
    actionAfterDays: 7,
    action: 'none',
    recipients: ['arcdev@avb.net']
  },
  prod: {
    enabled: false,
    reminderAfterDays: 7,
    actionAfterDays: 7,
    action: 'none',
    recipients: ['arcdev@avb.net']
  }
};
export const MEMBER_LIFECYCLE_CONFIG = MemberLifecycleConfigs[ARC_ENVIRONMENT];
export const IS_MEMBER_LIFECYCLE_ENABLED = MEMBER_LIFECYCLE_CONFIG.enabled;